import moment, { Moment } from 'moment';
import { FileTypes } from '../../enum/CirgsReportEnums';
import CirgsAbstractFile from './CirgsAbstractFile';

class CirgsCustomerAttachment extends CirgsAbstractFile {
  customerId?: string;

  constructor(bucketName: string, fileKey: string, fileName: string,
    fileType: FileTypes, fileApplicationType: string, customerId?: string, id?: string,
    createdAt?: Moment, updatedAt?: Moment) {
    super(bucketName, fileKey, fileName, fileType, fileApplicationType, id, createdAt, updatedAt);
    this.customerId = customerId;
  }

  public objectToBody() {
    return {
      ...super.objectToBody(),
      customerId: this.customerId,
    };
  }

  public static jsonToObject(object: any): CirgsCustomerAttachment {
    return new CirgsCustomerAttachment(
      object.bucketName,
      object.fileKey,
      object.fileName,
      object.fileType as FileTypes,
      object.fileApplicationType,
      object.customerId,
      object.id,
      moment(object.createdAt),
      moment(object.updatedAt),
    );
  }
}

export default CirgsCustomerAttachment;
